import {required as requiredValidation} from './validators';
import {Validator} from 'redux-form';

export const injectRequiredValidation = (required?: boolean, validate?: Validator | Array<Validator>) =>
    (): Array<Validator> => {
        // @ts-ignore
        let localValidate: Array<Validator> = validate || [];

        if (validate && !Array.isArray(validate)) {
            localValidate = [validate];
        }

        if (required) {
            localValidate.push(requiredValidation);
        }

        return localValidate;
    };